import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);
function introSlider() {
  var sliderContainer = '.js-intro-slider';
  new Swiper(sliderContainer, {
    speed: 400,
    slidesPerView: 1,
    direction: 'horizontal',
    loop: true,
    allowTouchMove: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    }
  });
}
function spotlightSlider() {
  var sliderContainer = '.js-spotlight-slider';
  new Swiper(sliderContainer, {
    speed: 400,
    slidesPerView: 1,
    direction: 'horizontal',
    loop: true,
    navigation: {
      nextEl: '.js-spotlight-button-next',
      prevEl: '.js-spotlight-button-prev'
    }
  });
}
function instagramSlider() {
  var sliderContainer = '.js-instagam-slider';
  new Swiper(sliderContainer, {
    speed: 400,
    spaceBetween: 15,
    watchSlidesVisibility: true,
    slidesPerView: 2,
    direction: 'horizontal',
    loop: true,
    allowTouchMove: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    breakpoints: {
      480: {
        slidesPerView: 4
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 30
      }
    }
  });
}
function relatedBlogsSlider() {
  var sliderContainer = '.js-related-blogs-slider';
  new Swiper(sliderContainer, {
    speed: 400,
    spaceBetween: 15,
    slidesPerView: 1,
    direction: 'horizontal',
    loop: true,
    allowTouchMove: true,
    navigation: {
      nextEl: '.js-related-blogs-slider-button-next',
      prevEl: '.js-related-blogs-slider-button-prev'
    },
    breakpoints: {
      375: {
        slidesPerView: 2
      },
      576: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 40
      }
    }
  });
}
export default function sliders() {
  introSlider();
  spotlightSlider();
  instagramSlider();
  relatedBlogsSlider();
}